<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Grupos de Activos Fijos</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link class="btn btn-sm btn-success" :to="{ name: 'af-grupos-nuevo', params: {} }">
                <i class="fa fa-plus"></i>
                Crear Nuevo
              </router-link>
              <a class href="#"></a>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
            <div class="col-sm-12">
              <div style="text-align: right;">
                <form class="form-inline justify-content-sm-end" @submit="filterData">
                  <input class="form-control form-control-sm rounded bright" placeholder="Buscar" v-model="searchtext"
                    type="text" />
                  <div class="input-group-append">
                    <button class="btn btn-link btn-sm" type="submit">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <!--<select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActivo"
                  @click="filterData"
                >
                  <option value="null">Todos</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select> -->
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-left">Código</th>
                <th class="text-left">Nombre</th>
                <th class="text-left">Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td class="text-left">{{ current.id }}</td>
                <td class="text-left">{{ current.nombre }}</td>
                <td class="text left">{{ current.descripcion }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import AfGruposService from "@/services/af/AfGruposService";

export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      data: []
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      AfGruposService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "af-grupos-editar",
        params: { id: current.id }
      });
    },
    showModalEdit() { }
  }
};
</script>
